import { isEmpty } from 'lodash'
import {
  FETCH_BANK_FAIL,
  FETCH_BANK_SUCCESS,
  FETCH_BANK_LOADING,
  UPDATE_BANK_LOADING,
  // UPDATE_BANK_SUCCESS,
  UPDATE_BANK_FAIL
} from '../actions/types'

const INITIAL_STATE = {
  loading: true,
  fail: false,
  data: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_BANK_SUCCESS:
      const data = isEmpty(action.payload) ? null : action.payload[0]
      return { fail: false, loading: false, data }

    case UPDATE_BANK_LOADING:
    case FETCH_BANK_LOADING:
      return { fail: false, loading: true, data: null }

    case UPDATE_BANK_FAIL:
    case FETCH_BANK_FAIL:
      return { fail: true, loading: false, data: null }

    default:
      return state
  }
}
